import styled from 'styled-components';

interface WrapperProps {
    // Used only temporarily to occupy invisible space behind
    // the absolutely positioned `YatPickerDropdown`.
    $tempHidden?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    position: relative;
    opacity: ${({ $tempHidden }) => ($tempHidden ? 0 : undefined)};
`;
